import { create } from "zustand";

// state authModal open / close
export const useOpenCloseAuthModalStore = create((set) => ({
  isOpen: false,
  // mode: null, // Add mode state
  open: (mode = null) => {
    set({ isOpen: true });
  },
  close: () => {
    set({ isOpen: false});
  },
  toggleAuthModal: () =>
    set((state) => {
      return { isOpen: !state.isOpen };
    }),
  setMode: (mode) => {
    set({ mode });
  },
}));
